<template>
	<div class="layer-project" data-project-name="lgWaterSolution">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">LG Water Solution</h1>
					<a
						href="http://www.lgwatersolutions.com "
						class="link"
						target="_blank"
						>www.lgwatersolutions.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						고객사의 니즈와 수처리 필터의 사업 특성을 고려하여 반응형 웹으로
						제작하여 안정감과 편의성을 부여한 사이트로 제작했습니다.
						<br class="blank pc" /><br class="blank mb" />직접적인 제품의
						노출보다는 사업분야에 관련된 이미지를 노출하여 브랜드 및 사업분야
						홍보에 집중했습니다.
					</p>
				</div>
				<div class="project-overview-diagram">
					<ul class="diagram01">
						<li class="item01">
							<strong>LG Chem</strong>
							<p><span>Membrane</span><span>NanoH<sub>2</sub>O™</span></p>
						</li>
					</ul>
					<ul class="diagram02">
						<li class="item01">
							<strong>BWRO</strong>Brackish Water RO Membrane
						</li>
						<li class="item02"><strong>SWRO</strong>Seawater RO Membrane</li>
						<li class="item03">
							<strong>TWRO</strong>Residential Water RO Membrane
						</li>
					</ul>
					<ul class="diagram03">
						<li>
							<span class="img01"
								><img
									src="/static/img/project-detail/lgwatersolution/overview-diagram-txt01.png"
							/></span>
							<span class="img02"
								><img
									src="/static/img/project-detail/lgwatersolution/overview-diagram-txt02.png"
							/></span>
						</li>
					</ul>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section section01">
				<div class="inner-section">
					<div class="cont-tit-area">
						<strong class="project-subtit">PC Web</strong>
						<p class="cont-desc">
							상단 키 비주얼 영역에 사업분야에 대한 사용자 이해가 쉽도록 깨끗한
							물의 이미지를 사용하여 브랜드 이미지를 부각시켰습니다.
							<br class="blank mb" /><br class="blank pc" />하단의 콘텐츠 영역은
							반응형 웹으로 구성하기 용이한 그리드 배너 형태로 구성했습니다.
							일반 사용자보다는 전문가가 많이 방문하는 사이트의 특성상 검색으로
							<br class="blank pc" />해당 제품으로 이동이 가능하도록 구성했으며,
							<br class="blank tb" />전체적으로 LG화학의 브랜드 아이덴티티를
							지키기 위한 컬러 시스템을 사용했습니다.
						</p>
					</div>
					<div class="detail-img">
						<div class="content cont01">
							<p class="shadow-box">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgwatersolution/sec1-cont01@m.png"
								/>
							</p>
						</div>
						<div class="content cont02">
							<p class="shadow-box">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgwatersolution/sec1-cont02@m.jpg"
								/>
							</p>
						</div>
						<div class="content cont03 mobile-swiper">
							<div class="swiper-wrapper shadow">
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img01@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img02@m.jpg"
									/>
								</div>
								<div class="swiper-slide exmb">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img03@mt.jpg"
										data-break="mt-w"
									/>
								</div>
								<div class="swiper-slide exmb">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img04@mt.jpg"
										data-break="mt-w"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img05@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img06@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgwatersolution/sec1-cont03-img07@m.jpg"
									/>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<section class="section section02 full">
				<div class="inner-section">
					<div class="cont-txt-area">
						<strong class="cont-tit">Responsive Design</strong>
						<p class="cont-desc">
							We designed the website to be responsive and
							<br class="blank mb" />focused on usability.
							<br class="blank pc" /><br class="blank tb" />Provide the same
							user <br class="blank mb" />experience across the web, tablet, and
							mobile.
						</p>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lgwatersolution/sec2-cont-@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section03 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">Mobile Web</strong>
					</div>
					<div class="detail-img">
						<div class="content cont01 max-limit">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgwatersolution/sec3-cont01@m.png"
							/>
						</div>
						<div class="cont-txt-area">
							<strong class="cont-tit">LG Water Solutions </strong>
							<p class="cont-desc">
								Water Solutions, part of LG Chem, Ltd.,
								<br class="blank mb" />manufactures the full line of NanoH2O™
								seawater, <br />brackish water and residential reverse
								osmosis<br class="blank mb" />
								(RO) membranes. <br class="blank tb" /><span class="rwd-tb"
									>NanoH2O™ RO membranes are<br class="blank pc mb" />
									developed based on<br class="blank tb" />innovative Thin
									Film<br class="blank mb" />
									Nanocomposite (TFN) technology.</span
								>
							</p>
						</div>
						<div class="content cont02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgwatersolution/sec3-cont02@m.jpg"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section section04">
				<div class="inner-section">
					<div class="detail-cont text">
						<p class="text01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgwatersolution/sec4-cont-img01@m.jpg"
							/>
						</p>
						<p class="text02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgwatersolution/sec4-cont-img02@m.jpg"
							/>
						</p>
					</div>
					<div class="detail-cont color">
						<dl>
							<dt data-color="#000000"></dt>
							<dd>#000000</dd>
						</dl>
						<dl>
							<dt data-color="#333333"></dt>
							<dd>#333333</dd>
						</dl>
						<dl>
							<dt data-color="#666666"></dt>
							<dd>#666666</dd>
						</dl>
						<dl>
							<dt data-color="#a10c35"></dt>
							<dd>#a10c35</dd>
						</dl>
						<dl>
							<dt data-color="#7583a9"></dt>
							<dd>#7583a9</dd>
						</dl>
						<dl>
							<dt data-color="#eeeeee"></dt>
							<dd>#eeeeee</dd>
						</dl>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">LG Water Solution</strong>
			</section>
			<!-- Details [e] -->
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		//onload
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					spaceBetween: 15,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}
		$window.off("resize").on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
	methods: {},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.layer-project-detail > section.full {
	padding-bottom: 0;
}
.project-subtit {
	line-height: 1.2;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .cont-tit-area {
	word-break: keep-all;
}
.section .cont-tit {
	font-weight: 500;
}
.section .detail-img {
	text-align: center;
}
.section p {
	word-break: keep-all;
}
.blank {
	display: none;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding-left: 15px;
		padding-right: 15px;
	}
	.blank.mb {
		display: block;
	}
	.shadow-box,
	.shadow img {
		box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.1);
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding-left: 40px;
		padding-right: 40px;
	}
	.blank.tb {
		display: block;
	}
	.shadow-box,
	.shadow img {
		box-shadow: 0px 25px 20px 0px rgba(0, 0, 0, 0.1);
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.blank.tb {
		display: none;
	}
	.blank.pc {
		display: block;
	}
	.shadow-box,
	.shadow img {
		box-shadow: 0px 70px 60px 0px rgba(0, 0, 0, 0.1);
	}
}
/* Project Visual, Project CI */
.project-client {
	background: #666 url(/static/img/project-detail/lgwatersolution/ci.png) 50% /
		auto 19px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgwatersolution/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgwatersolution/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 25.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgwatersolution/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 51px;
	}
}

/* Overview */
.project-overview {
	background-color: #6298ce;
	color: #fff;
}
.project-overview-diagram {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
}
.project-overview-diagram ul {
	position: relative;
}
.project-overview-diagram ul:not(.diagram02) li {
	border-radius: 50%;
}
.project-overview-diagram ul:not(.diagram03)::after {
	transform: rotate(45deg);
}
.project-overview-diagram ul:not(.diagram03)::before,
.project-overview-diagram ul:not(.diagram03)::after {
	position: absolute;
	content: "";
	display: block;
	background-color: #fff;
}
.project-overview-diagram .diagram01 li {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border: 1px solid #fff;
	width: 170px;
	height: 170px;
}
.project-overview-diagram .diagram01 p {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 15px;
}
.project-overview-diagram .diagram01 span {
	width: 75px;
	height: 75px;
	margin: 0 -5px;
	font-size: 12px;
	line-height: 75px;
	color: #222;
	border-radius: 50%;
	background-color: #fff;
}
.project-overview-diagram .diagram01 strong {
	font-weight: 500;
}
.project-overview-diagram .diagram02 {
	width: 230px;
	border: 1px solid rgba(255, 255, 255, 0.8);
}
.project-overview-diagram .diagram02 li {
	height: 60px;
	padding: 15px 0;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.8);
}
.project-overview-diagram .diagram02 li:not(.item03) {
	border-bottom: 1px solid rgba(255, 255, 255, 0.8);
}
.project-overview-diagram .diagram02 strong {
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: rgba(255, 255, 255, 1);
	line-height: 1.2;
	letter-spacing: 0.5px;
}
.project-overview-diagram .diagram03 {
	margin-bottom: 0;
}
.project-overview-diagram .diagram03 li {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 150px;
	height: 150px;
	line-height: 1.2;
	background-color: #3b6a9c;
}
.project-overview-diagram .diagram03 span {
	width: 117px;
	margin-top: 5px;
}
.project-overview-diagram .diagram03 .img01 {
	width: 117px;
}
.project-overview-diagram .diagram03 .img02 {
	width: 45px;
}

@media screen and (max-width: 711px) {
	.project-overview-diagram {
		flex-direction: column;
	}
	.project-overview-diagram ul {
		margin: 22px 0;
	}
	.project-overview-diagram .diagram01 strong {
		font-size: 16px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 1px;
		height: 28px;
		left: 50%;
		bottom: -28px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 1px;
		height: 7px;
		left: calc(50% + 4px);
		bottom: -28px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		padding-top: 35px;
	}
	.project-overview-diagram ul {
		margin: 0 22px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 28px;
		height: 1px;
		top: 50%;
		right: -28px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 7px;
		height: 1px;
		top: calc(50% - 3px);
		right: -28px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-diagram {
		padding: 35px 0;
	}
	.project-overview-diagram ul {
		margin: 30px 70px 0;
	}
	.project-overview-diagram .diagram01 li {
		width: 283px;
		height: 283px;
	}
	.project-overview-diagram .diagram01 p {
		margin-top: 25px;
	}
	.project-overview-diagram .diagram01 strong {
		font-size: 20px;
	}
	.project-overview-diagram .diagram01 span {
		width: 125px;
		height: 125px;
		margin: 0 -9px;
		font-size: 14px;
		line-height: 125px;
	}
	.project-overview-diagram .diagram02 {
		width: 412px;
	}
	.project-overview-diagram .diagram02 li {
		height: 100px;
		padding: 25px 0;
		font-size: 14px;
	}
	.project-overview-diagram .diagram02 strong {
		font-size: 20px;
		margin-bottom: 5px;
	}
	.project-overview-diagram .diagram03 li {
		width: 271px;
		height: 269px;
	}
	.project-overview-diagram .diagram03 span {
		width: 194px;
		margin-top: 12px;
	}
	.project-overview-diagram .diagram03 .img01 {
		width: 194px;
	}
	.project-overview-diagram .diagram03 .img02 {
		width: 75px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 62px;
		height: 1px;
		top: 50%;
		right: -100px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 14px;
		height: 1px;
		top: calc(50% - 6px);
		right: -100px;
	}
}
/* section1 */
.section01 {
	background-color: #f3f3f3;
}
@media screen and (max-width: 711px) {
	.section01 .detail-img {
		padding-top: 14px;
	}
	.section01 .content:not(.cont03) {
		margin-bottom: 25px;
	}
	.section01 .mobile-swiper {
		position: relative;
		padding-bottom: 35px;
	}
	.section01 .mobile-swiper .swiper-slide.exmb {
		display: none;
	}
	.section01 .cont01 .shadow-box {
		border-radius: 10px;
		overflow: hidden;
	}
}
@media screen and (min-width: 712px) {
	.section01 .cont-tit-area {
		padding-bottom: 50px;
	}
	.section01 .detail-img .cont01 {
		margin-bottom: 78px;
	}
	.section01 .detail-img .cont01 .shadow-box {
		border-radius: 14px;
		overflow: hidden;
	}
	.section01 .detail-img .cont02 {
		padding-bottom: 78px;
		background: url(/static/img/project-detail/lgwatersolution/sec1-cont02-bg.png)
			50% 95% no-repeat;
		background-size: 85.7vw;
		box-shadow: none;
	}
	.section01 .detail-img .cont02 .shadow-box {
		width: 66.71vw;
		margin: 0 auto;
	}
	.section01 .detail-img .swiper-wrapper {
		position: relative;
		display: block;
		min-height: 164vw;
	}
	.section01 .detail-img .swiper-slide {
		position: absolute;
		width: 41.71vw;
		height: auto;
	}
	.section01 .detail-img .swiper-slide:nth-child(odd) {
		left: calc(50% - 43.3vw);
	}
	.section01 .detail-img .swiper-slide:nth-child(even) {
		left: calc(50% + 2.8vw);
	}
	.section01 .detail-img .swiper-slide:nth-child(3) {
		top: 51.5vw;
	}
	.section01 .detail-img .swiper-slide:nth-child(4) {
		top: 53.7vw;
	}
	.section01 .detail-img .swiper-slide:nth-child(5) {
		top: 100.8vw;
	}
	.section01 .detail-img .swiper-slide:nth-child(6) {
		top: 84.3vw;
	}
	.section01 .detail-img .swiper-slide:nth-child(7) {
		top: 134.3vw;
		left: calc(50% + 2.8vw);
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		background: #f3f3f3
			url(/static/img/project-detail/lgwatersolution/sec1-cont02-bg.png) 36%
			34.6% no-repeat;
		background-size: 1732px;
	}
	.section01 .cont-tit-area {
		padding: 50px 0;
	}
	.section01 .cont-desc {
		line-height: 1.8;
	}
	.section01 .detail-img .cont01 {
		margin-bottom: 138px;
	}
	.section01 .detail-img .cont01 .shadow-box {
		border-radius: 20px;
		overflow: hidden;
	}
	.section01 .detail-img .cont02 {
		padding-bottom: 222px;
		background: none;
	}
	.section01 .detail-img .cont02 .shadow-box {
		width: auto;
		margin: 0 auto;
	}
	.section01 .detail-img .swiper-wrapper {
		min-height: 3250px;
	}
	.section01 .detail-img .swiper-slide {
		width: 800px;
	}
	.section01 .detail-img .swiper-slide:nth-child(odd) {
		left: calc(50% - 837px);
	}
	.section01 .detail-img .swiper-slide:nth-child(even) {
		left: calc(50% + 48px);
	}
	.section01 .detail-img .swiper-slide:nth-child(3) {
		top: 990px;
	}
	.section01 .detail-img .swiper-slide:nth-child(4) {
		top: 1031px;
	}
	.section01 .detail-img .swiper-slide:nth-child(5) {
		top: 1950px;
	}
	.section01 .detail-img .swiper-slide:nth-child(6) {
		top: 1620px;
	}
	.section01 .detail-img .swiper-slide:nth-child(7) {
		top: 2592px;
		left: calc(50% + 48px);
	}
}
/* section2 */
.section02 {
	text-align: center;
}
.section02 .cont-tit {
	font-size: 20px;
}
.section02 .cont-txt-area {
	background-color: #fff;
}
.section02 .cont-desc {
	margin-top: 10px;
	font-size: 12px;
	color: #666666;
	letter-spacing: 0;
}
.section02 .detail-img {
	background-color: #373737;
}
@media screen and (max-width: 711px) {
	.section02 .cont-desc {
		margin-top: 8px;
	}
	.section02 .detail-img {
		margin-top: 37px;
		padding: 47px 15px 62px;
	}
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section02 {
		padding: 0;
	}
	.section02 {
		background-color: #373737;
	}
	.section02 .cont-txt-area {
		padding: 40px 0;
	}
	.section02 .detail-img {
		padding: 50px 70px;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section02 {
		padding: 0;
	}
	.section02 .cont-txt-area {
		padding: 100px 0;
	}
	.section02 .cont-tit {
		font-size: 36px;
		line-height: 1.2;
	}
	.section02 .cont-desc {
		margin-top: 22px;
		font-size: 16px;
		color: #666666;
	}
	.section02 .detail-img {
		padding: 100px 0px;
	}
}
/* section3 */
.section03 {
	background-color: #e2e2e2;
}
.section03 .project-subtit {
	margin-bottom: 0;
}
.section03 .cont-txt-area {
	background-color: #fff;
}
.section03 .cont-tit {
	font-size: 20px;
}
.section03 .cont-desc {
	margin-top: 10px;
	font-size: 12px;
	color: #666666;
	letter-spacing: 0;
}
@media screen and (max-width: 711px) {
	.section03 .project-subtit {
		margin-bottom: 22px;
	}
	.section03 .cont01 {
		padding-bottom: 50px;
	}
	.section03 .cont-txt-area {
		padding: 35px 0;
	}
}
@media screen and (min-width: 712px) {
	.section03 .cont01 {
		padding-bottom: 40px;
	}
	.section03 .cont-txt-area {
		padding: 50px 0;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		padding-top: 50px;
	}
	.section03 .cont01 {
		padding-bottom: 100px;
	}
	.section03 .cont-txt-area {
		padding: 100px 0;
	}
	.section03 .cont-tit {
		font-size: 36px;
		line-height: 1.2;
	}
	.section03 .cont-desc {
		margin-top: 22px;
		font-size: 16px;
		color: #666666;
	}
}
/* section4 */
.section04 .text {
	display: flex;
}
.section04 .color {
	display: flex;
	flex-wrap: wrap;
}
.section04 .color dt {
	border-radius: 50%;
	margin: 0 auto;
}
.section04 .color dl {
	text-align: center;
}
.section04 .color dt {
	border-radius: 50%;
}
.section04 .color dt[data-color="#000000"] {
	background-color: #000000;
}
.section04 .color dt[data-color="#333333"] {
	background-color: #333333;
}
.section04 .color dt[data-color="#666666"] {
	background-color: #666666;
}
.section04 .color dt[data-color="#a10c35"] {
	background-color: #a10c35;
}
.section04 .color dt[data-color="#7583a9"] {
	background-color: #7583a9;
}
.section04 .color dt[data-color="#eeeeee"] {
	background-color: #eeeeee;
}
.section04 .color dd {
	font-size: 12px;
	letter-spacing: 0.5px;
}
@media screen and (max-width: 711px) {
	.section04 .text {
		flex-direction: column;
	}
	.section04 .text p {
		margin-bottom: 38px;
	}
	.section04 .color {
		justify-content: center;
	}
	.section04 .color dl {
		padding: 13px 6.9vw;
	}
	.section04 .color dt {
		width: 45px;
		height: 45px;
	}
	.section04 .color dd {
		margin-top: 10px;
	}
}
@media screen and (min-width: 712px) {
	.section04 .text p {
		margin: 38px 0;
	}
	.section04 .text p img {
		width: 40.1685vw;
	}
	.section04 .detail-cont {
		justify-content: space-between;
	}
	.section04 .color dl {
		padding: 13px 21px;
	}
	.section04 .color dt {
		width: 45px;
		height: 45px;
	}
	.section04 .color dd {
		margin-top: 10px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .text p {
		margin: 125px 0;
	}
	.section04 .text p img {
		width: auto;
	}
	.section04 .detail-cont {
		justify-content: space-between;
	}
	.section04 .color {
		margin-bottom: 165px;
	}
	.section04 .color dl {
		padding: 0 16px;
	}
	.section04 .color dt {
		width: 90px;
		height: 90px;
	}
	.section04 .color dd {
		margin-top: 10px;
		font-size: 14px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/lgwatersolution.vue